module.exports = __webpack_public_path__ + "img/icon-dropdown.e0797467.svg";